import React, { useState, useEffect } from "react";
import "../../assets/styles/products.css";
import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate
import Footer from "../footer/footer";
import { IoMdArrowRoundBack } from "react-icons/io";

const Products = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Initialize navigate for back navigation
  const [isNavigated, setIsNavigated] = useState(false);

  // ** Set CAT6 Ethernet Cables as the default selection (index 0) **
  const [activeIndex, setActiveIndex] = useState(0);
  const [showItemss, setShowItemss] = useState(true);
  const [selectedItemss, setSelectedItemss] = useState(0); // Always start with CAT6 Ethernet

  useEffect(() => {
    setActiveIndex(0);
    setSelectedItemss(0);
    setShowItemss(true);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const toggleItemss = (index) => {
    if (selectedItemss === index) {
      setSelectedItemss(null);
    } else {
      setSelectedItemss(index);
    }
    setIsNavigated(false); // Reset navigation state
  };

  const handleDoubleClick = () => {
    setSelectedItemss(0); // Reset to default category
  };

  const itemss = [
    ["CAT6 Ethernet", "Cables"], // Default Selection
    ["CAT5E Ethernet", "Cables"],
    ["Ethernet", " Cables"],
    ["CAT6 Ethernet", "Cables"],
    ["Cable Rolls &", "Boxes"],
  ];

  const productGroups = [
    [
      // Group 1: CAT6 Ethernet Cables (Default)
      { sku: "P1001", name: "CAT6 UTP Patch Cable - 1m" },
      { sku: "P1002", name: "CAT6 UTP Patch Cable - 2m" },
      { sku: "P1003", name: "CAT6 UTP Patch Cable - 3m" },
      { sku: "P1004", name: "CAT6 UTP Patch Cable - 5m" },
    ],
    [
      // Group 2: CAT5E Ethernet Cables
      { sku: "P2001", name: "CAT5E UTP Patch Cable - 1m" },
      { sku: "P2002", name: "CAT5E UTP Patch Cable - 2m" },
      { sku: "P2003", name: "CAT5E UTP Patch Cable - 3m" },
      { sku: "P2004", name: "CAT5E UTP Patch Cable - 5m" },
    ],
    [
      // Group 3: Ethernet Cables
      { sku: "P3001", name: "Flat Ethernet Cable - 1m" },
      { sku: "P3002", name: "Flat Ethernet Cable - 2m" },
      { sku: "P3003", name: "Flat Ethernet Cable - 3m" },
      { sku: "P3004", name: "Flat Ethernet Cable - 5m" },
    ],
    [
      // Group 4: CAT6 Ethernet Cables
      { sku: "P3501", name: "CAT6 Shielded Cable - 1m" },
      { sku: "P3502", name: "CAT6 Shielded Cable - 2m" },
      { sku: "P3503", name: "CAT6 Shielded Cable - 3m" },
      { sku: "P3504", name: "CAT6 Shielded Cable - 5m" },
    ],
    [
      // Group 5: Cable Rolls & Boxes
      { sku: "P4001", name: "100m Ethernet Cable Roll" },
      { sku: "P4002", name: "200m Ethernet Cable Roll" },
      { sku: "P4003", name: "300m Ethernet Cable Roll" },
      { sku: "P4004", name: "500m Ethernet Cable Roll" },
    ],
  ];

  return (
    <>
      <div
        className="app"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "25vh",
          backgroundColor: "#18181C",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          color: "#FFFFFF",
        }}
        onDoubleClick={handleDoubleClick}
      >
        {/* Back Icon in Top Left */}
        <IoMdArrowRoundBack
          className="back-icon"
          onClick={() => navigate(-1)} // Navigate back on click
          style={{
            position: "absolute",
            top: "20px",
            left: "30px",
            fontSize: "2rem",
            color: "#B3FF00",
            cursor: "pointer",
          }}
        />
        {itemss.map((lines, index) => (
          <div
            key={index}
            style={{
              textAlign: "center",
              cursor: "pointer",
              paddingBottom: "2px",
              color: selectedItemss === index ? "#B3FF00" : "#FFFFFF",
            }}
            className={`hover-effect ${
              selectedItemss === index ? "active" : ""
            }`}
            onClick={() => toggleItemss(index)}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#B3FF00")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.color =
                selectedItemss === index ? "#B3FF00" : "#FFFFFF")
            }
          >
            <p style={{ margin: 0, fontSize: "1.7rem" }}>{lines[0]}</p>
            <p style={{ margin: 0, fontSize: "1.7rem" }}>{lines[1]}</p>
          </div>
        ))}
      </div>

      {selectedItemss !== null && (
        <div className="products-container">
          <div className="sidebar">
            <div className="filter-section">
              <h5 className="filter-title">Length</h5>
              <ul>
                <li>
                  <input type="checkbox" /> 0.1M
                </li>
                <li>
                  <input type="checkbox" /> 0.15M
                </li>
                <li>
                  <input type="checkbox" /> 0.18M
                </li>
                <li>
                  <input type="checkbox" /> 0.2M
                </li>
                <li>
                  <input type="checkbox" /> 0.22M
                </li>
                <li>
                  <input type="checkbox" /> 0.25M
                </li>
                <li>
                  <input type="checkbox" /> 0.3M
                </li>
                <li>
                  <input type="checkbox" /> 0.31M
                </li>
                <li>
                  <input type="checkbox" /> 0.5M
                </li>
                <li>
                  <input type="checkbox" /> 0.75M
                </li>
              </ul>
            </div>
            <div className="filter-section">
              <h5 className="filter-title">Colour</h5>
              <ul>
                <li>
                  <input type="checkbox" /> BLACK
                </li>
                <li>
                  <input type="checkbox" /> WHITE
                </li>
                <li>
                  <input type="checkbox" /> BLUE
                </li>
                <li>
                  <input type="checkbox" /> GREY
                </li>
                <li>
                  <input type="checkbox" /> RED
                </li>
                <li>
                  <input type="checkbox" /> YELLOW
                </li>
                <li>
                  <input type="checkbox" /> ORANGE
                </li>
                <li>
                  <input type="checkbox" /> PINK
                </li>
                <li>
                  <input type="checkbox" /> GREEN
                </li>
                <li>
                  <input type="checkbox" /> PURPLE
                </li>
              </ul>
            </div>
          </div>
          <div className="product-grid">
            {productGroups[selectedItemss].map((product, i) => (
              <div key={i} className="product-card">
                <div className="product-image"></div>
                <p className="sku">SKU: {product.sku}</p>
                <p className="product-name">{product.name}</p>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="productfooter">
        <Footer />
      </div>
    </>
  );
};

export default Products;
